<template>
    <div class="contactme">
        <h3>Contact Me</h3>
        <hr>
        <b-container style="padding-top: 0">
            <b-row>
                <b-col lg="6">
                    <b-row style="margin-bottom: 25px;">
                        <b-col>
                            <b>Contact Form</b>
                        </b-col>
                    </b-row>
                    <b-row style="padding-bottom: 12px;">
                        <b-col sm="6">
                            <b-form-input v-model="formInput.name" placeholder="Name"></b-form-input>
                        </b-col>
                        <b-col sm="6">
                            <b-form-input v-model="formInput.email" placeholder="Email"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row style="padding-bottom: 12px">
                        <b-col>
                            <b-form-textarea
                                v-model="formInput.message"
                                placeholder="Message"
                                rows="6"
                            ></b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-button variant="info" @click="onSubmit()" style="float: left">Submit</b-button>
                        </b-col>
                    </b-row>
                </b-col>                
                <b-col lg="6" style="padding-left: 50px;">
                    <b-row style="margin-bottom: 25px;">
                        <b-col>
                            <b>Contact Information</b>
                        </b-col>
                    </b-row>
                    <Info :icon=true />
                    <b-row>
                        <b-col>
                            <b-button pill variant="outline-secondary" 
                                style="margin-right: 20px; width: 70px"
                                href="https://www.linkedin.com/in/henrik-davidsen" target="_blank"
                            >
                                <i class="fab fa-linkedin fa-lg"></i>
                            </b-button>
                            <b-button pill variant="outline-secondary" 
                                style="margin-right: 20px; width: 70px"
                                href="https://www.github.com/hdavidsen" target="_blank"
                            >
                                <i class="fab fa-github-square fa-lg"></i>
                            </b-button>
                            <b-button pill variant="outline-secondary" 
                                style="width: 70px;"
                                href="https://www.facebook.com/henrik.davidsen.90" target="_blank"
                            >
                                <i class="fab fa-facebook-square fa-lg"></i>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
        <GoogleMaps/>
    </div>
</template>

<script>
import Vue from 'vue'
import Info from '@/components/Info'
import VueNotification from '@mathieustan/vue-notification';
import GoogleMaps from '@/components/GoogleMaps'
import axios from 'axios'

Vue.use(VueNotification, {
  theme: {
    colors: {
      success: '#3AD571',
      error: '#EA0B0B'
    }
  }
});

export default {
    name: 'ContactMe',
    components: {
        Info,
        GoogleMaps
    },
    data () {
        return {
            errors: [],
            formInput: {
                name: '',
                email: '',
                message: ''
            },
        }
    },
    methods: {
        onSubmit() {

            let valid = this.validateFormInput(this.formInput);

            if(valid) {
                axios.post('https://henrikdavidsen.com/api/contactform', 
                    { name: this.formInput.name, email: this.formInput.email, message: this.formInput.message})
                .then(response => {
                    if(response.status == 200) {
                        this.$notify({
                            message: "Successfully sent!",
                            type: "success",
                            top: true,
                            bottom: true,
                            left: false,
                            right: true,
                            offset: -300,
                            showClose: true,
                            closeDelay: 2000,
                        });
                    } 
                })
                .catch(() => {
                    this.$notify({
                        message: "Oh no! Something went wrong. Please try again later",
                        type: "error",
                        top: true,
                        bottom: true,
                        left: false,
                        right: true,
                        offset: -300,
                        showClose: true,
                        closeDelay: 2000
                    })
                });

                this.formInput.name = '';
                this.formInput.email = '';
                this.formInput.message = '';
            } else {
                for(let i = 0; i < this.errors.length; i++) {
                    this.$notify.error({
                        message: this.errors[i],
                        type: 'error',
                        top: true,
                        bottom: true,
                        left: false,
                        right: true,
                        offset: ((-300)+(i*150)),
                        showClose: true,
                        closeDelay: 2000,
                    });
                }
            }
        },
        validateFormInput(form) {
            this.errors = [];

            if(!form.name) {
                this.errors.push("Name required");
            }

            if(!form.email) {
                this.errors.push("Email required");
            }

            if(!form.message) {
                this.errors.push("Message required");
            }

            if(!this.errors.length) {
                return true;
            }

            return false;
        }
    }
}
</script>

<style scoped>
.contactme {
    background: white;
    border-radius: 10px;
}
</style>